import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SwitchAccount } from "../../models/user";
import {
  saveState,
  loadState,
  removeState,
} from "../browser-storage/browser-storage";

type InitialState = {
  switchAccounts: any[];
};
const type = "switchAccounts";

const initialState: InitialState = {
  switchAccounts: loadState(type) || [],
};

export const switchAccountsSlice = createSlice({
  name: type,
  initialState: initialState,
  reducers: {
    setSwitchAccounts: (state, action: PayloadAction<any>) => {
      console.log("action.payload", state, action.payload);
      let existIndex = state.switchAccounts.findIndex(
        (user) => user.userId === action.payload.userId
      );
      if (existIndex >= 0) state.switchAccounts[existIndex] = action.payload;
      else state.switchAccounts.push(action.payload);
      saveState(type, state.switchAccounts);
    },
    removeSwitchAccounts: (state, action: PayloadAction<any>) => {
      state.switchAccounts = state.switchAccounts.filter(
        (user) => user.userId !== action.payload.userId
      );
      saveState(type, state.switchAccounts);
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSwitchAccounts, removeSwitchAccounts } =
  switchAccountsSlice.actions;

export default switchAccountsSlice.reducer;
